<template>
  <section class="section small">
    <div class="container">
      <div class="right">
        <ul>
          <slot></slot>
        </ul>
      </div>
    </div>
  </section>
</template>

<style lang="css" scoped>
.right {
  float: right;
}
</style>

<script>
export default {};
</script>
